// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.rabby",
    name: "Rabby",
    homepage: "https://rabby.io/",
    image_id: "255e6ba2-8dfd-43ad-e88e-57cbb98f6800",
    app: {
        browser: "https://chrome.google.com/webstore/detail/rabby/acmacodkjbdgmoleebolmdjonilkdbch",
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "io.rabby",
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map